import { Channel, ChannelType } from "@/models/channel";

export const getDefaultTextChannel = (channels: Channel[] = []) => {
    const textChannels = channels.filter(c => c.type === ChannelType.TEXT);

    const general = textChannels.find(
        c => c.name?.toLowerCase() === 'general'
    );

    return general || textChannels[0] || null;
};